var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultiple10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.21 16.86H2.954V9.07H1V7.346L5.21 7v9.86zM8 17H6v-2h2v2zm7.338-3.712c0 1.162-.31 2.07-.927 2.727-.619.657-1.435.985-2.449.985-1.023 0-1.843-.328-2.461-.985-.618-.656-.928-1.565-.928-2.727v-2.576c0-1.162.307-2.07.921-2.727C10.108 7.328 10.926 7 11.95 7c1.014 0 1.832.33 2.455.988.623.659.934 1.567.934 2.724v2.576zm-2.248-2.73c0-.592-.101-1.044-.304-1.355-.202-.312-.481-.467-.837-.467a.93.93 0 0 0-.834.467c-.196.311-.293.763-.293 1.355v2.87c0 .606.099 1.063.296 1.372.198.31.48.464.844.464.356 0 .633-.154.83-.464.199-.309.298-.766.298-1.371v-2.87zm6.354 1.208h.04l.914-2.13h2.529l-2.095 3.572L23 16.86h-2.528l-.96-2.196h-.04l-.962 2.196h-2.528l2.168-3.652-2.101-3.571h2.515l.88 2.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M5 20v-1H3v3h18v-3h-2v1zM5 3v1H3V1h18v3h-2V3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiple10);
export default __webpack_public_path__ + "static/media/multiple-1-0.a1e7724a.svg";
export { ForwardRef as ReactComponent };